import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';
import { CollectionSettingCard } from './collection/CollectionSettingCard';
import CustomLoader from '../common/CustomLoader';
import CollectionHeaderNav from './CollectionHeaderNav';
import types from '../../common/formElements/CollectionSectionType';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { COLLECTION, FIELD } from 'drapcode-constant';
export class CollectionEdit extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { projectId, collectionId, version } = this.props.match.params;
    this.props.actions.loadProjectCollections({ projectId, version });
    this.props.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    this.props.actions.loadProjectDetailCollections({ projectId, version });
    this.props.actions.getPermissionFlags({ projectId });
  }

  shouldComponentUpdate = (nextProps, nextState, nextContext) => {
    if (nextProps.match.url !== this.props.match.url) {
      const { projectId, collectionId, version } = nextProps.match.params;
      nextProps.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    }
    return true;
  };

  render() {
    const { collections, actions, history, homeActions, match, home } = this.props;
    const { projectId, collectionId, version } = match.params;
    const {
      loadProjectCollectionsPending,
      loadProjectCollectionDetailPending,
      selectedCollection,
      currentCollectionListPage,
      totalCollectionPages,
      permissionFlags,
    } = collections;
    const { snippets } = home;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    return (
      <CommonPageComponent parentClassName="collections-collection-edit">
        <CollectionHeaderNav
          label={types.FIELDS}
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          loadProjectCollectionsPending={loadProjectCollectionsPending}
          loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
        />
        {loadProjectCollectionsPending || loadProjectCollectionDetailPending ? (
          <div className="text-center">
            <CustomLoader
              loading={loadProjectCollectionsPending || loadProjectCollectionDetailPending}
              size="20px"
              color="#303453"
            />
          </div>
        ) : (
          <CollectionSettingCard
            collections={collections}
            actions={actions}
            version={version}
            homeActions={homeActions}
            projectId={projectId}
            history={history}
            currentCollectionListPage={currentCollectionListPage}
            totalCollectionPages={totalCollectionPages}
            collectionFlag={permissionsArray.includes(COLLECTION)}
            fieldFlag={permissionsArray.includes(FIELD)}
            snippets={snippets}
          />
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionEdit);
